import styled, { css } from 'styled-components';
import { IconContainer } from '../../../../icon';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const ICON_SIZE = 20;
/**
 * ReceiptGroupTitle
 */
export const receiptGroupTitleStyles = ({ theme, $isHighlighted, }) => css `
	display: flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing[200])};
	margin: 0;
	color: ${$isHighlighted
    ? theme.colors.action.textMemberReceipt
    : theme.colors.base.textPriceReceipt};

	${IconContainer} {
		width: ${pxToRem(ICON_SIZE)};
		height: ${pxToRem(ICON_SIZE)};

		/* The highlighted text will only be used for the membership icon which should be blue */
		color: ${$isHighlighted ? theme.colors.membership['2Years'] : theme.colors.base.iconUi};
	}
`;
export const StyledReceiptGroupTitle = styled(Typography).attrs({
    variant: 'label-title',
    tagName: 'h3',
}) `
	${receiptGroupTitleStyles}
`;
